// 存放公共接口调用
import { isPlanOrVisit } from '@/api/workPlace/visits.js'

// 判断去用药计划还是随访记录详情
export const isPlanOrVisitMethods = async (dataParams, cb) => {
  const { serialNumber = undefined, id = undefined } = dataParams
  const params = {
    serialNumber,
    businessId: id
  }
  const res = await isPlanOrVisit(params)
  const data = {
    id: res?.medicationScheduleId,
    dateFlg: res.ifNew
  }
  cb(data)
}
